import { schema } from 'normalizr';

const accountPhoneSchema = new schema.Entity('accountPhones', {}, { idAttribute: 'uuid' });

export default accountPhoneSchema;
